<edp-loader *ngIf="showLoader" [size]="'md'" [position]="'center'"></edp-loader>

<div class="overlay-more-info d-flex h-100 flex-column" *ngIf="step === 1">
    <div class="overlay-more-info-header">
        <button (click)="selectOverlay('user')" class="btn btn-close" type="button">
            <i class="icon icon-edponline-Bop-078 icon-2x rotate-180" aria-hidden="true"></i>
        </button>
        <div class="d-flex">
            <h2>{{ "pt.edp.edponline.moreInfo.title" | translate }}</h2>
        </div>
    </div>

    <div class="overlay-more-info-body flex-grow-1" *ngIf="!showLoader">
        <p class="more-info-header-body">
            {{ "pt.edp.edponline.moreInfo.subTitle" | translate }}
        </p>
        <div class="more-info-card" *ngFor="let contract of complementaryInfo; let i = index" (click)="selectContract(i); step = 2">
            <div class="icon-container">
                <i *ngIf="contract.supplyType === 'E'" class="icon icon-edponline-Bra-001" aria-hidden="true"></i>
                <i *ngIf="contract.supplyType === 'G'" class="icon icon-edponline-Bra-009" aria-hidden="true"></i>
                <i *ngIf="contract.supplyType === 'D'" class="icon icon-edponline-Bra-003" aria-hidden="true"></i>
            </div>
            <div class="main">
                <div class="nickname mb-2">{{ contract.nickname }}</div>
                <div class="address">{{ contract.street }} {{ contract.houseNumber }}, {{ contract.postalCode }} {{ contract.city }}</div>
            </div>

            <div class="progress-container">
                <edp-rounded-progress [size]="'md'" class="text-center my-auto" [percentage]="contract.percentage"></edp-rounded-progress>
            </div>
        </div>
    </div>
</div>

<div class="overlay-more-info d-flex h-100 flex-column" *ngIf="step === 2 && !showLoader">
    <div class="selected-contract-header">
        <button (click)="step = 1" class="btn btn-close" type="button">
            <i class="icon icon-edponline-Bop-078 icon-2x rotate-180" aria-hidden="true"></i>
        </button>

        <div class="d-flex selected-contract">
            <div class="icon-container">
                <i *ngIf="selectedContract.supplyType === 'E'" class="icon icon-edponline-Bra-001" aria-hidden="true"></i>
                <i *ngIf="selectedContract.supplyType === 'G'" class="icon icon-edponline-Bra-009" aria-hidden="true"></i>
                <i *ngIf="selectedContract.supplyType === 'D'" class="icon icon-edponline-Bra-003" aria-hidden="true"></i>
            </div>
            <div class="main">
                <div class="nickname mb-2">{{ selectedContract.nickname }}</div>
                <div class="address">
                    {{ selectedContract.street }} {{ selectedContract.houseNumber }}, {{ selectedContract.postalCode }}
                    {{ selectedContract.city }}
                </div>
            </div>
            <div class="progress-container">
                <edp-rounded-progress
                    [size]="'md'"
                    class="text-center my-auto"
                    [percentage]="questionPercentageTotal"
                ></edp-rounded-progress>
            </div>
        </div>
    </div>

    <div class="complementary-form">
        <p class="title">{{ "pt.edp.edponline.moreInfo.form.title" | translate }}</p>
        <p class="subtitle">{{ "pt.edp.edponline.moreInfo.form.subtitle" | translate }}</p>

        <form [formGroup]="form" class="edp-form" (ngSubmit)="submitForm()">
            <p>{{ "pt.edp.edponline.moreInfo.question1" | translate }}</p>
            <div class="btn-group-container btn-group btn-group-toggle toggle-group mb-4">
                <input id="housingType-1" class="radio-button" type="radio" value="Moradia" formControlName="housingType" />
                <label class="btn btn-primary" for="housingType-1">{{ "pt.edp.edponline.moreInfo.answer1-1" | translate }}</label>

                <input id="housingType-2" class="radio-button" type="radio" value="Apartamento" formControlName="housingType" />
                <label class="btn btn-primary" for="housingType-2">{{ "pt.edp.edponline.moreInfo.answer1-2" | translate }}</label>
            </div>

            <p>{{ "pt.edp.edponline.moreInfo.question2" | translate }}</p>
            <div class="btn-group-container btn-group btn-group-toggle toggle-group mb-4">
                <input id="utilization-1" class="radio-button" type="radio" value="Permanente" formControlName="utilization" />
                <label class="btn btn-primary" for="utilization-1">{{ "pt.edp.edponline.moreInfo.answer2-1" | translate }}</label>

                <input id="utilization-2" class="radio-button" type="radio" value="Sazonal" formControlName="utilization" />
                <label class="btn btn-primary" for="utilization-2">{{ "pt.edp.edponline.moreInfo.answer2-2" | translate }}</label>
            </div>

            <p>{{ "pt.edp.edponline.moreInfo.question3" | translate }}</p>
            <div class="btn-group-container btn-group btn-group-toggle toggle-group mb-4">
                <input id="residents-1" class="radio-button" type="radio" value="1" formControlName="residents" />
                <label class="btn btn-primary" for="residents-1">{{ "pt.edp.edponline.moreInfo.answer3-1" | translate }}</label>

                <input id="residents-2" class="radio-button" type="radio" value="2" formControlName="residents" />
                <label class="btn btn-primary" for="residents-2">{{ "pt.edp.edponline.moreInfo.answer3-2" | translate }}</label>

                <input id="residents-3" class="radio-button" type="radio" value="3" formControlName="residents" />
                <label class="btn btn-primary" for="residents-3">{{ "pt.edp.edponline.moreInfo.answer3-3" | translate }}</label>

                <input id="residents-4" class="radio-button" type="radio" value="4" formControlName="residents" />
                <label class="btn btn-primary" for="residents-4">{{ "pt.edp.edponline.moreInfo.answer3-4" | translate }}</label>

                <input id="residents-5" class="radio-button" type="radio" value="5" formControlName="residents" />
                <label class="btn btn-primary" for="residents-5">{{ "pt.edp.edponline.moreInfo.answer3-5" | translate }}</label>

                <input id="residents-6" class="radio-button" type="radio" value="6" formControlName="residents" />
                <label class="btn btn-primary" for="residents-6">{{ "pt.edp.edponline.moreInfo.answer3-6" | translate }}</label>

                <input id="residents-7" class="radio-button" type="radio" value="7+" formControlName="residents" />
                <label class="btn btn-primary" for="residents-7">{{ "pt.edp.edponline.moreInfo.answer3-7" | translate }}</label>
            </div>

            <p *ngIf="selectedContract.supplyType === 'E'">{{ "pt.edp.edponline.moreInfo.question4" | translate }}</p>
            <div class="btn-group-container btn-group btn-group-toggle toggle-group mb-4" *ngIf="selectedContract.supplyType === 'E'">
                <input id="hasGas-1" class="radio-button" type="radio" value="1" formControlName="hasGas" (change)="gasSubForm = true" />
                <label class="btn btn-primary" for="hasGas-1">{{ "pt.edp.edponline.moreInfo.answer4-1" | translate }}</label>

                <input id="hasGas-2" class="radio-button" type="radio" value="0" formControlName="hasGas" (change)="gasSubForm = false" />
                <label class="btn btn-primary" for="hasGas-2">{{ "pt.edp.edponline.moreInfo.answer4-2" | translate }}</label>
            </div>

            <div *ngIf="gasSubForm" class="sub-form" formGroupName="gasCheckboxGroup" [ngClass]="{ 'form-submitted': formSubmitted }">
                <p>{{ "pt.edp.edponline.moreInfo.question5" | translate }}</p>
                <div class="btn-group-container btn-group btn-group-toggle flex-column mb-4">
                    <label class="form-check-label pl-5">
                        <input id="hasGasKitchen-1" class="form-check-input" type="checkbox" formControlName="hasGasKitchen" />
                        <span class="form-check-mark"></span>
                        <label for="hasGasKitchen-1">{{ "pt.edp.edponline.moreInfo.answer5-1" | translate }}</label>
                    </label>

                    <label class="form-check-label pl-5">
                        <input id="hasGasWaterHeating-1" class="form-check-input" type="checkbox" formControlName="hasGasWaterHeating" />
                        <span class="form-check-mark"></span>
                        <label for="hasGasWaterHeating-1">{{ "pt.edp.edponline.moreInfo.answer5-2" | translate }}</label>
                    </label>

                    <label class="form-check-label pl-5">
                        <input id="hasGasHeating-1" class="form-check-input" type="checkbox" formControlName="hasGasHeating" />
                        <span class="form-check-mark"></span>
                        <label for="hasGasHeating-1">{{ "pt.edp.edponline.moreInfo.answer5-3" | translate }}</label>
                    </label>
                </div>
            </div>

            <p>{{ "pt.edp.edponline.moreInfo.question6" | translate }}</p>
            <div class="btn-group-container btn-group btn-group-toggle toggle-group mb-4">
                <input
                    id="hasWaterBomb-1"
                    class="radio-button"
                    type="radio"
                    value="1"
                    formControlName="hasWaterBomb"
                    (change)="waterSubForm = true"
                />
                <label class="btn btn-primary" for="hasWaterBomb-1">{{ "pt.edp.edponline.moreInfo.answer6-1" | translate }}</label>

                <input
                    id="hasWaterBomb-2"
                    class="radio-button"
                    type="radio"
                    value="0"
                    formControlName="hasWaterBomb"
                    (change)="waterSubForm = false"
                />
                <label class="btn btn-primary" for="hasWaterBomb-2">{{ "pt.edp.edponline.moreInfo.answer6-2" | translate }}</label>
            </div>

            <div *ngIf="waterSubForm" class="sub-form" formGroupName="waterCheckboxGroup" [ngClass]="{ 'form-submitted': formSubmitted }">
                <p>{{ "pt.edp.edponline.moreInfo.question7" | translate }}</p>
                <div class="btn-group-container btn-group btn-group-toggle flex-column mb-4">
                    <label class="form-check-label pl-5">
                        <input id="hasWaterBombPool-1" class="form-check-input" type="checkbox" formControlName="hasWaterBombPool" />
                        <span class="form-check-mark"></span>
                        <label for="hasWaterBombPool-1">{{ "pt.edp.edponline.moreInfo.answer7-1" | translate }}</label>
                    </label>

                    <label class="form-check-label pl-5">
                        <input
                            id="hasWaterBombGardening-1"
                            class="form-check-input"
                            type="checkbox"
                            formControlName="hasWaterBombGardening"
                        />
                        <span class="form-check-mark"></span>
                        <label for="hasWaterBombGardening-1">{{ "pt.edp.edponline.moreInfo.answer7-2" | translate }}</label>
                    </label>

                    <label class="form-check-label pl-5">
                        <input
                            id="hasWaterBombHydropressure-1"
                            class="form-check-input"
                            type="checkbox"
                            formControlName="hasWaterBombHydropressure"
                        />
                        <span class="form-check-mark"></span>
                        <label for="hasWaterBombHydropressure-1">{{ "pt.edp.edponline.moreInfo.answer7-3" | translate }}</label>
                    </label>
                </div>
            </div>

            <div>
                <p>{{ "pt.edp.edponline.moreInfo.question8" | translate }}</p>
                <div class="btn-group-container btn-group btn-group-toggle toggle-group mb-4">
                    <input
                        id="electricCar-1"
                        class="radio-button"
                        type="radio"
                        value="1"
                        formControlName="electricCar"
                    />
                    <label class="btn btn-primary" for="electricCar-1">{{ "pt.edp.edponline.moreInfo.answer8-1" | translate }}</label>

                    <input
                        id="electricCar-2"
                        class="radio-button"
                        type="radio"
                        value="0"
                        formControlName="electricCar"
                    />
                    <label class="btn btn-primary" for="electricCar-2">{{ "pt.edp.edponline.moreInfo.answer8-2" | translate }}</label>
                </div>
            </div>

            <div *ngIf="electricCarSubForm" [ngClass]="{ 'form-submitted': formSubmitted }">
                <p>{{ "pt.edp.edponline.moreInfo.question9" | translate }}</p>
                <div class="btn-group-container btn-group btn-group-toggle toggle-group mb-4">
                    <input
                        id="chargeElectricCarHome-1"
                        class="radio-button"
                        type="radio"
                        value="1"
                        formControlName="chargeElectricCarHome"
                    />
                    <label class="btn btn-primary" for="chargeElectricCarHome-1">
                        {{ "pt.edp.edponline.moreInfo.answer9-1" | translate }}
                    </label>

                    <input
                        id="chargeElectricCarHome-2"
                        class="radio-button"
                        type="radio"
                        value="0"
                        formControlName="chargeElectricCarHome"
                    />
                    <label class="btn btn-primary" for="chargeElectricCarHome-2">
                        {{ "pt.edp.edponline.moreInfo.answer9-2" | translate }}
                    </label>
                </div>
                <div *ngIf="form.controls['chargeElectricCarHome'].pristine && formSubmitted">
                    <p class="error">{{ "pt.edp.edponline.moreInfo.required" | translate }}</p>
                </div>
            </div>

            <div class="overlay-more-info-footer">
                <button type="submit">
                    <span class="text-botton">{{ "pt.edp.edponline.moreInfo.confirm" | translate }}</span>
                </button>
            </div>
        </form>
    </div>
</div>
